import { VerifyEmailTokenQuery } from '../queries';

export const toVerifiedStatus = (
  result: VerifyEmailTokenQuery['verifyEmailToken'] | undefined
) =>
  result?.__typename === 'UserStatusItem' && result.email
    ? { ...result, email: result.email }
    : undefined;
